import React from 'react';

export default function MapLoadingElement({active = true}) {
  if (!active) {
    return null;
  }
  return (
    <div>Загрузка...</div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/Map/MapLoadingElement.jsx
 **/